import {ClientModel} from "interfaces";

export const clientInitialState: ClientModel = {
  id: "",
  mp: "",
  pq: "",
  tipo: 1,
  nac: "",
  edad: 0,
  ubch: "",
  email: "",
  edo: null,
  status: 1,
  cod_mp: "",
  cod_pq: "",
  nombre: "",
  cedula: "",
  gender: "",
  telefono: "",
  cod_ubch: "",
  apellido: "",
  fecha_nac: "",
  cod_edo: null,
  direccion: "",
  formularios: [],
};
